import React, { useEffect, useRef, useState } from "react"
import { GoogleMap as DefaultGoogleMap, Marker, Polyline, withGoogleMap } from "react-google-maps"
import { compose, withProps } from "recompose"

let GoogleMap: any = DefaultGoogleMap;

const SimpleMap = compose(
  withProps((props) => ({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyDV8uT7yErfIloYQBp_PXlEyJnTBWJ3Hpk",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: props.height || `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  })),
  withGoogleMap
)((props) => {
  const mapRef = useRef<any>();
  const bouncedRef = useRef<boolean>(false);

  let defaultCenter = {
    lat: -13.6601,
    lng: -48.8738,
  }

  useEffect(() => {
    bouncedRef.current = false;
  }, [[...(props.markers ?? []), ...(props.icons ?? [])].length])

  useEffect(() => {
    const markers = [...(props.markers ?? []), ...(props.icons ?? [])];
    if(!bouncedRef.current && markers.length > 0){
      let wd : any = window;
      let google = wd.google;
      var bounds = new google.maps.LatLngBounds();

      if(markers.length > 0){
        for (var i = 0; i < markers.length; i++) {
          bounds.extend(markers[i]);
        }
        for( var index in markers ) {
          var latlng = markers[index];
          bounds.extend(latlng);
        }

        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
          var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
          var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
          bounds.extend(extendPoint1);
          bounds.extend(extendPoint2);
        }
      }else{
        bounds.extend(props.origin ?? defaultCenter); 
      }

      mapRef?.current?.fitBounds && mapRef?.current?.fitBounds(bounds);
      bouncedRef.current = true;
    }
  }, [props.origin, props.markers, props.icons])

  const markerStyle = {
    color: 'red', // Default color if not provided
    fontSize: 16, // Default font size if not provided
    fontWeight: 'bold',
    padding: '5px',
    borderRadius: '50%',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
  }

  return <>
    <GoogleMap
      ref={mapRef}
      defaultZoom={4}
      defaultCenter={defaultCenter}
      // options={{ maxZoom: 17 }}
    >
      {(props.markers ?? []).length > 0
      ? props.line
        ? <Polyline
          path={props.markers}
          options={{
            strokeColor: "#f21201",
            strokeOpacity: 1,
            strokeWeight: 4
          }}
        />
        : props.markers.map((m, i) => <Marker options={{icon: props.icon}} key={`${i}`} position={m} onClick={e => props.onMarkerClick && props.onMarkerClick(e, { index: i, position: m })} />)
      : <Marker options={{icon: props.icon}} position={props.origin} onClick={e => props.onMarkerClick && props.onMarkerClick(e, { index: 0, position: props.origin })} />}

      {props.location && <Marker options={{icon: props.icon}} position={props.location}/>}
      {(props.icons ?? []).map((m, i) => <Marker options={{icon: m.icon}} key={`${i}`} position={m} onClick={() => props.onPoint && props.onPoint({item: m, index: i})} /> )}
    </GoogleMap>
  </>
})

export default SimpleMap;
